import { ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline'

const AGENT_LABELS = {
  faq: 'FAQ Agent',
  appointment: 'Appointment Agent',
  'lead-capture': 'Lead Capture Agent',
  'knowledge-base': 'Knowledge Base Agent',
}

export default function AgentPriorityList({ priority, onChange }) {
  const moveUp = (index) => {
    if (index <= 0) return
    const next = [...priority]
    ;[next[index - 1], next[index]] = [next[index], next[index - 1]]
    onChange(next)
  }

  const moveDown = (index) => {
    if (index >= priority.length - 1) return
    const next = [...priority]
    ;[next[index], next[index + 1]] = [next[index + 1], next[index]]
    onChange(next)
  }

  return (
    <div className="space-y-1.5">
      {priority.map((slug, index) => (
        <div
          key={slug}
          className="flex items-center gap-3 bg-white border border-slate-200 rounded-lg px-3 py-2"
        >
          <span className="w-6 h-6 rounded-full bg-slate-100 text-slate-500 flex items-center justify-center text-xs font-medium">
            {index + 1}
          </span>
          <span className="flex-1 text-sm text-slate-700">{AGENT_LABELS[slug] || slug}</span>
          <div className="flex items-center gap-1">
            <button
              onClick={() => moveUp(index)}
              disabled={index === 0}
              className="p-1 rounded hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed text-slate-400"
            >
              <ArrowUpIcon className="h-3.5 w-3.5" />
            </button>
            <button
              onClick={() => moveDown(index)}
              disabled={index === priority.length - 1}
              className="p-1 rounded hover:bg-slate-100 disabled:opacity-30 disabled:cursor-not-allowed text-slate-400"
            >
              <ArrowDownIcon className="h-3.5 w-3.5" />
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}
